import React from 'react'
import ProgressTitle from '../dashboard_build/components/progressTitle'
import ProgressDescription from '../dashboard_build/components/progressDescription'
import BenefitsContainer from '../dashboard_build/containers/benefitsContainer'

class BuildContainer extends React.Component {

  constructor () {
    super()

    this.state = {
      progressTitle: "We are setting up your LeavePlan",
      progressDescription: "Your Customized LeavePlan is being created based on leave\
      benefits and helpful tasks that match your \
      specific leave scenario",
      showPrompt: false,
      benefits: [
      ]
    }
  }

  waitCalculation () {
    const defer = $.Deferred()
    $("#complete-leave-plan")
      .on ("ajax:success", ((e, data) => {
        defer.resolve(e, data)
      }).bind(this))
    return defer.promise()
  }

  getData (data) {
    const dataArr = data.data
    // dataArr.reduce ( (a, b) => Number(a) + Number(b), 0)
    this.setState ( {
      progressTitle: "Searching For Benefits...",
      progressDescription: "We are automatically matching you with the Benefits \
        you are potentially eligible for to support your leave",
      benefits: [
        {
          type: "paid",
          number: dataArr[0],
          showProgress: false,
          index: 0,
          showRow: false,
        },
        {
          type: "job-protection",
          number: dataArr[1],
          index: 1,
          showProgress: false,
          showRow: false,
        },
        {
          type: "other",
          number: dataArr[2],
          index: 2,
          showProgress: false,
          showRow: false
        }
      ],
      redirectUrl: data.redirect_url,
      showContinueDashboard: false
    } )
  }

  _pluralize (word) {
    return word[word.length-1] == "s" ?
      word + "es" : word + "s"
  }

  pluralize (word, count, type) {
    if ( (type === "verb" && Number( count ) === 1) || (type === "noun" && Number( count ) >1)) {
      return this._pluralize (word)
    }

    return word
  }

  componentDidMount () {
    document.getElementById("complete-leave-plan")
      .addEventListener("click", ((e) => {
        document.getElementById('create-leave-plan').style.display = "none"
        $('.prev-step-link').remove()
        this.setState ({
          ...this.state,
          showPrompt: true
        })
      }).bind(this), false);

    this.waitCalculation()
      .then ( ((e, data) => {
        if (data.calculated) {
          this.getData(data)
        }
      }).bind(this))
  }

  updateTitle (title) {
    this.setState ({
      ...this.state,
      ...title
    })
  }

  showContinueDashboard () {
    this.setState ({
      ...this.state,
      showContinueDashboard: true
    })
  }

  addClass (element, newClass) {
    element.className += ` ${newClass}`;
  }

  closePrompt () {
    window.location = this.state.redirectUrl
  }

  getContinueDashboard () {
    return this.state.showContinueDashboard ?
      <div
        className="continue-dashboard"
        onClick={this.closePrompt.bind(this)}>
        Continue to my Dashboard
      </div>:
      <div className="hidden"></div>
  }

  warningMessage() {
    return this.state.showContinueDashboard ? 
      <div className="row warning-message">
        <div className="col-md-1 col-sm-1 fa-2x col-lg-1 exclamation-icon">
          <i className='fa fa-exclamation-triangle' />
        </div>
        <div className="col-md-11 col-sm-11 col-lg-11">
          <b> Remember: </b>To actually receive the benefits outlined in this draft plan, you must file to submit for approval.
        </div>
      </div>: <div className="hidden"></div>
  }

  renderContinueDashboard(){
    return(
      <div className="dashbuild-container">
        <div className="dashbuild-title">
          <div className="dashbuild-logo">
          </div>
        </div>
        <div className="dashbuild-content">
          <div className="content-wrapper">
            <div className="title-description">
              <ProgressTitle text={this.state.progressTitle} />
              <ProgressDescription text={this.state.progressDescription} />
            </div>
            <div className="progress-summary-container">
              <BenefitsContainer
                benefits={this.state.benefits}
                showContinueDashboard={this.showContinueDashboard.bind(this)}
                updateTitle={this.updateTitle.bind(this)}
                pluralize={this.pluralize.bind(this)}
                paidLeaveSubstitution={this.props.paidLeaveSubstitution}
                jobProtectedLeaveSubstitution={this.props.jobProtectedLeaveSubstitution}
              />
            </div>
            { gon.employee_layout == 'unum_theme' ? this.warningMessage() : ''}
            <div className="continue-dashboard-container">
              { this.getContinueDashboard() }
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (this.state.showPrompt ? (
      <div>{this.renderContinueDashboard()}</div>
      ) :
      <div className="hidden"></div>
    )
  }
}

export default BuildContainer;

